import { render, staticRenderFns } from "./LicenseExpiringNotification.vue?vue&type=template&id=167b1c43"
import script from "./LicenseExpiringNotification.vue?vue&type=script&lang=js"
export * from "./LicenseExpiringNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports